
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-commitment",
      function () {
        return require("private-next-pages/our-commitment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-commitment"])
      });
    }
  